module.exports = __webpack_public_path__ + "static/media/habba-habba-ad.4c8a1d74.jpeg";